import React from "react";
import PopupWithForm from "../PopupWithForm/PopupWithForm";
import { CurrentUserContext } from "../../context/CurrentUserContext";
import { useTranslation } from "../../utils/hooks/translateHook";


  export default function Signout ({ isOpen, onClose, onSignOut }) {
    const { currentUser } = React.useContext(CurrentUserContext);
    const t = useTranslation();

    return (
      <PopupWithForm
        isOpen={isOpen}
        onClose={onClose}
        name="signout"
        title={t('logout')}
        isButtonEnabled={true}
        buttonText=""
        hideDefaultButton={true}
        closeButtonClassName='signout-close'
        formClassName="signout"
        contentClassName="signout"
      >

      <div style={{ textAlign: 'center', marginBottom: 18 }}>
        <b>{currentUser?.name}</b><br></br>
        {t('logoutQuestion')}
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', width:'100%' }}>
        <button type="button" className="popup__button signout" 
          onClick={() => {
            onSignOut();
            onClose();
          }}
        > {t('yes')} </button>
        <button type="button" className="popup__button popup__button_secondary signout" onClick={onClose}>
          {t('no')}
        </button>
      </div>

      </PopupWithForm>
    )
  }